import { FileInfo } from "../types/emergency";

// 이미지 배열중 medium -> full -> 맨 첫 인덱스 순으로 리턴, 아무것도 없으면 undefined 리턴
export const findOptimizedImgUrl = (items: FileInfo[] | undefined) => {
  if (items && items.length > 0) {
    const medium = items.find((file) => file.scale === "medium");
    if (medium) {
      return medium.url;
    } else {
      const full = items.find((file) => file.scale === "full");
      if (full) {
        return full.url;
      } else {
        // medium 도 full 도 없음
        return items[0].url;
      }
    }
  } else {
    return undefined;
  }
};
